import {put, select, takeLatest} from 'redux-saga/effects';
import {
  GET_SALES_PER_ITEM,
  GET_SALES_PER_ITEM_SUCCESS
} from 'store/analyticsSalesPerItem/action';
import {getAnalyticsV3SalesPerItemApi} from 'helpers/services/api/analytics';
import {
  normalizeSalesPerItem,
  unwrapAnalyticsPayload
} from 'helpers/services/api/analyticsHelpers';
import {ANALYTICS_SORT_FIELDS} from '../../helpers/constants/analytics';

function* getSalesPerItem({payload}) {
  try {
    const {locationId} = yield select((state) => state.user);
    const sortingKey =
      ANALYTICS_SORT_FIELDS[payload.orderBy] ?? payload.orderBy ?? 'rank';

    // Standalone v3 endpoint — paging never reloads the whole dashboard.
    const response = yield getAnalyticsV3SalesPerItemApi(locationId, {
      startDate: payload.startDate,
      endDate: payload.endDate,
      channelTypes: payload.channelTypes,
      fulfillmentModes: payload.fulfillmentModes,
      paging: (payload.page ?? 0) + 1,
      pageSize: payload.pageSize,
      sortingKey,
      sortingDirection: payload.order
    });
    const {items, totalCount} = normalizeSalesPerItem(
      unwrapAnalyticsPayload(response),
      payload.pageSize
    );
    yield put(
      GET_SALES_PER_ITEM_SUCCESS({
        items,
        totalCount
      })
    );
  } catch (error) {
    yield put(
      GET_SALES_PER_ITEM_SUCCESS({
        items: [],
        totalCount: 0
      })
    );
    console.log('SAGA ERROR', error);
  }
}

function* analyticsSalesPerItemSaga() {
  yield takeLatest(GET_SALES_PER_ITEM, getSalesPerItem);
}

export default analyticsSalesPerItemSaga;
